module.exports = __webpack_public_path__ + "img/device-list.3e5a4a5c.jpg";